import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import { useSelector } from "react-redux";
import BigCard from "../Components/BigCard";
const Home = () => {
  const imagesObj = useSelector((state) => state.banner);
  const imagesArray = Object.values(imagesObj);
  const images = imagesArray[0];
  useEffect(() => {
    imagesArray[0].map((image) => console.log(image));
  });
  return (
    <div>
      <Navbar />
      <div className="home">
        <div className="homeee" style={{marginBottom:'40px'}}>
        <div
          id="carouselExampleControls"
          class="carousel slide "
          data-bs-ride="carousel"
        >
          <div class="carousel-inner">
            {images.map((image) => (
              <div class="carousel-item active" style={{ height: "70vh" }}>
                <img src={image} class="d-block w-100" style={{height:'100%'}} alt="..." />
                <div>
                </div>
              </div>
            ))}
          </div>
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleControls"
            data-bs-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
        <div className="titleDiv">
      <p className="title">
        <span>MAKE YOUR MIND <br/> AND <br/>YOUR WALL GRACEFUL </span>
        <br/>
        <hr/>
          Transforming blank canvases 
          <br/>
          and your home into
          <br />
          worlds of imagination 
          <br/>
          and innovation.
        </p>

        <button className="shop">Shop Now</button>
      </div>
      </div>
      <BigCard/>
    </div>
    </div>
  );
};

export default Home;
